var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOptimism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "optimism-logo-circle",
    transform: "translate(-219 -213)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 61,
    cy: 61,
    r: 61,
    transform: "translate(219 213)",
    fill: "#fe0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M23.98-39.38a18.785,18.785,0,0,1,9.048,2.062,14.311,14.311,0,0,1,5.885,5.83,17.864,17.864,0,0,1,2.063,8.718,26.89,26.89,0,0,1-.44,4.565A23.142,23.142,0,0,1,36.6-8.553,21.053,21.053,0,0,1,29.04-1.98,21.55,21.55,0,0,1,18.975.385a19.07,19.07,0,0,1-9.13-2.063A14.141,14.141,0,0,1,3.96-7.48a17.9,17.9,0,0,1-2.035-8.69,27.42,27.42,0,0,1,.44-4.675A23.142,23.142,0,0,1,6.3-30.5a20.741,20.741,0,0,1,7.59-6.545A21.924,21.924,0,0,1,23.98-39.38Zm-.605,7.15a12.485,12.485,0,0,0-8.69,3.355,15.61,15.61,0,0,0-4.73,9.02,21.1,21.1,0,0,0-.275,3.08,9.906,9.906,0,0,0,2.64,7.287A9.753,9.753,0,0,0,19.58-6.82a12.66,12.66,0,0,0,6.105-1.513,13.438,13.438,0,0,0,4.73-4.318,15.881,15.881,0,0,0,2.53-6.545,16.086,16.086,0,0,0,.275-3.135,9.811,9.811,0,0,0-2.64-7.26A9.736,9.736,0,0,0,23.375-32.23Zm32.67,17.82L53.515,0H45.76l6.82-38.83H66.715q5.995,0,8.965,2.53a8.75,8.75,0,0,1,2.97,7.04,15.729,15.729,0,0,1-.22,2.695,13.991,13.991,0,0,1-5.17,8.855q-4.18,3.3-10.835,3.3ZM62.7-20.625q6.765,0,7.865-5.94a7.916,7.916,0,0,0,.11-1.485,4.1,4.1,0,0,0-1.4-3.355A7.025,7.025,0,0,0,64.79-32.56H59.235l-2.09,11.935Z",
    transform: "translate(241 294)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimism);
export default __webpack_public_path__ + "static/media/optimism.62e4c6c1bd629dd909578b7bf41b2075.svg";
export { ForwardRef as ReactComponent };